const viewModelConfig = require('./viewmodel-config');

module.exports = viewModelConfig;
